<template>
	<div id="sre-case">
		<h2>成功案例</h2>
		<p>某金融科技公司多云管理项目
			MoPaaS 为某金融科技公司提供服务可靠性整体解决方案。对客户公司云资源进行统一纳管，梳理自服务流程，实现了日常运维规范化、自动化。
		</p>
		<div class="box">
			<div class="section">
				<h3>方案优势</h3>
				<div class="item" :class="{'active':active==item.id+1}" v-for="item in advantages" :key="item.id">
					<i class="iconfont" :class="item.iconUrl" />
					<div class="content">
						<h4>{{item.title}}</h4>
						<p>{{item.content}}</p>
					</div>
				</div>
			</div>
			<div class="section">
				<h3>项目成效</h3>
				<div class="item" :class="{'active':active==item.id+1}" v-for="item in effects" :key="item.id">
					<i class="iconfont" :class="item.iconUrl" />
					<div class="content">
						<h4>{{item.title}}</h4>
						<p>{{item.content}}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'SreCase',
		data() {
			return {
				active: 0,
				advantages: [{
					id: 0,
					title: '集中管理',
					iconUrl: 'icon-jizhongguanli',
					content: '通过一键开通维图云管平台，可以无缝对接纳管异构资源，降低用户的多云管理成本。'
				}, {
					id: 1,
					title: '平滑迁移',
					iconUrl: 'icon-zhandianpinghuaqianyi',
					content: '使现有异构资源快速融入多云资源池，用户可在不同云之间快速平滑迁移应用。'
				}, {
					id: '2',
					title: '成本监控',
					iconUrl: 'icon-chengbenjiankongfenxi',
					content: '结合成本管理服务提供灵活便捷的成本分析，基于自定义成本优化策略及时反馈成本优化建议，提醒用户合理使用资源，降低用云成本。'
				}],
				effects: [{
					id: 3,
					title: '实现跨云集中管理',
					iconUrl: 'icon-kuaqun',
					content: '将Azure、阿里云、腾讯云和本地物理机进行统一纳管，实现跨云集中管理，有效降低管理成本。'
				}, {
					id: 4,
					title: '有效提高运维能力',
					iconUrl: 'icon-tigaoxiaoliang',
					content: '通过维图自定义自动化工具使其日常运维工作脚本化、规范化，并且梳理编排完成符合其公司业务需求的流程化工具，大大降低了运维成本，提高了运维能力水平。'
				}, {
					id: 5,
					title: '极大地降低运维成本',
					iconUrl: 'icon-xiajiang',
					content: '方便管理员和财务人员灵活统计分析多云成本，结合自定义成本优化策略的提醒，及时采取降配、调整计费方式等措施，使云资源成本降低20%以上。'
				}]
			}
		},
		methods: {
			activeMe(index) {
				this.active = index
			}
		}
	}
</script>

<style>
	@media(min-width:992px) {
		#sre-case {
			width: 100%;
			height: 801px;
			background-color: #04375D;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
		}

		#sre-case h2 {
			font-size: 36px;
			font-family: SimHei;
			font-weight: bold;
			color: #FFFFFF;
			margin-top: 74px;
		}

		#sre-case p {
			font-size: 18px;
			font-family: SimHei;
			font-weight: 400;
			color: #E5F3FE;
			margin: 16px 0 16px;
			line-height: 38px;
			white-space: pre-wrap;
		}

		#sre-case .box {
			width: 61%;
			/* height: 449px; */
			display: flex;
			flex-flow: row wrap;
			justify-content: space-between;
			align-items: flex-start;
		}

		#sre-case .box .section {
			width: 44%;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
		}

		#sre-case .box .section h3 {
			font-size: 22px;
			font-family: SimHei;
			font-weight: 400;
			color: rgba(238, 245, 253, 1);
			margin-bottom: 20px;
		}

		#sre-case .box .section .item {
			display: flex;
			justify-content: flex-start;
			align-items: flex-start;
			width: 100%;
			height: 136px;
			transition: .6s;
			-moz-transition: .6s;
			-webkit-transition: .6s;
			-moz-transition: .6s;
		}

		#sre-case .box .section .item:nth-child(3),
		#sre-case .box .section .item:nth-child(4) {
			height: 167px;
		}

		#sre-case .box .section .item:hover {
			background: rgba(238, 245, 253, 0.04);
			box-shadow: 0px 3px 7px 0px rgba(1, 43, 75, 0.1);
			border-radius: 2px;
		}

		#sre-case .box .section .item i {
			font-size: 24px;
			background: linear-gradient(0deg, rgba(0, 172, 180, 1), rgba(0, 235, 246, 1), rgba(0, 244, 255, 1), rgba(0, 235, 246, 1));
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			margin: 31px 21px 0 25px;
		}

		#sre-case .box .section .item .content {
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
			margin-top: 32px;
			width: 78.5%;
		}

		#sre-case .box .section .item .content h4 {
			font-size: 18px;
			font-family: SimHei;
			font-weight: 400;
			color: rgba(0, 235, 246, 1);
		}

		#sre-case .box .section .item .content p {
			font-size: 14px;
			font-family: SimSun;
			font-weight: 400;
			color: rgba(181, 235, 237, 1);
			text-align: left;
			line-height: 24px;
		}
	}

	@media(max-width:992px) {
		#sre-case {
			width: 100%;
			background-color: #04375D;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
		}

		#sre-case h2 {
			font-size: 0.2rem;
			font-family: SimHei;
			font-weight: bold;
			color: #FFFFFF;
			margin-top: 35px;
		}

		#sre-case p {
			font-size: 0.12rem;
			width: 90%;
			font-family: SimHei;
			font-weight: 400;
			color: #E5F3FE;
			margin: 0.16rem 0 0.16rem;
			line-height: 1.1;
			white-space: pre-wrap;
		}

		#sre-case .box {
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
		}

		#sre-case .box .section {
			width: 90%;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
			margin-bottom: 0.1rem;
		}

		#sre-case .box .section h3 {
			font-size: 0.16rem;
			font-family: SimHei;
			font-weight: 400;
			color: rgba(238, 245, 253, 1);
			margin-bottom: 0.1rem;
		}

		#sre-case .box .section .item {
			display: flex;
			justify-content: flex-start;
			align-items: flex-start;
			width: 100%;
			transition: .6s;
			-moz-transition: .6s;
			-webkit-transition: .6s;
			-moz-transition: .6s;
		}

		#sre-case .box .section .item:nth-child(3),
		#sre-case .box .section .item:nth-child(4) {}

		#sre-case .box .section .item.active {
			background: rgba(238, 245, 253, 0.04);
			box-shadow: 0px 3px 7px 0px rgba(1, 43, 75, 0.1);
			border-radius: 2px;
		}

		#sre-case .box .section .item i {
			font-size: 0.25rem;
			background: linear-gradient(0deg, rgba(0, 172, 180, 1), rgba(0, 235, 246, 1), rgba(0, 244, 255, 1), rgba(0, 235, 246, 1));
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			margin: 0.15rem 0.21rem 0 0.2rem;
		}

		#sre-case .box .section .item .content {
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
			margin-top: 0.2rem;
			width: 85%;
		}

		#sre-case .box .section .item .content h4 {
			font-size: 0.14rem;
			font-family: SimHei;
			font-weight: 400;
			color: rgba(0, 235, 246, 1);
		}

		#sre-case .box .section .item .content p {
			font-size: 0.12rem;
			font-family: SimSun;
			font-weight: 400;
			color: rgba(181, 235, 237, 1);
			text-align: left;
			line-height: 1.1;
			margin-top: 0.1rem;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/SreCase.vue